module.exports = __webpack_public_path__ + "img/11825395_L.a38e6be6.png";